import {
  DateInput,
  FilterForm,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

export const ReportingFiltersForm = () => {
  return (
    <FilterForm
      filters={[
        <ReferenceInput
          key="brand_id"
          source="brand_id"
          reference="reports/offers-by-brand"
          label="common.text.brand"
          alwaysOn
          resettable
          perPage={Infinity}
          sort={{ field: 'name', order: 'ASC' }}
        >
          <SelectInput optionText="brand_name" resettable />
        </ReferenceInput>,
        <DateInput
          key="date_from"
          source="date_from"
          label="common.text.start"
          alwaysOn
        />,
        <DateInput
          key="date_to"
          source="date_to"
          label="common.text.end"
          alwaysOn
        />,
      ]}
    />
  );
};
